export enum GeometryType {
    ANY,
    POLYGON,
    POINT,
    POLYLINE
}